export const REFRESH_USER_COUNT = "REFRESH_USER_COUNT";

import { get, put, post, destroy, upload } from "utils/fetchRequest";

export const uploadImage = async (data) => {
  try {
    const result = await upload("files/news", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const uploadExcel = async (data) => {
  try {
    // backend: POST /news/excel (multer-ээр файлыг задлан news мөрүүд үүсгэнэ)
    const result = await upload("news/excel", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsList = async (
  searchText,
  type,
  authorId,
  page,
  pageLimit,
  role,
  userRole,
  location
) => {
  try {
    const result = await get(
      `news?1=1${searchText ? `&search=${encodeURIComponent(searchText)}` : ""}${page ? `&page=${page}` : ""}${pageLimit ? `&limit=${pageLimit}` : ""}${type ? `&type=${type}` : ""}${role ? `&branch=${role}` : ""}${userRole ? `&userRole=${userRole}` : ""}${location ? `&location=${encodeURIComponent(location)}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsListAllData = async (searchText, role, location) =>
  // searchText,
  // type,
  // authorId,
  // page,
  // pageLimit,
  // role,
  // userRole
  {
    try {
      // const result = await get(`news/Alldata?1=1`);
      const result = await get(
        `news/Alldata?1=1${searchText ? `&search=${encodeURIComponent(searchText)}` : ""}${role ? `&branch=${role}` : ""}${location ? `&location=${encodeURIComponent(location)}` : ""}`
      );

      return result;
    } catch (err) {
      return { error: err };
    }
  };

export const getNewsDelivery = async (searchText) => {
  try {
    const result = await get(
      `news/delivery?1=1${searchText ? `&search=${encodeURIComponent(searchText)}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsListUser = async (searchText) => {
  try {
    const result = await get(
      `news/count?1=1${searchText ? `&search=${encodeURIComponent(searchText.trim())}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsContent = async (newsId) => {
  try {
    const result = await get(`news/${newsId}`);
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const createNews = async (data) => {
  try {
    const result = await post("news", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const updateNews = async (id, data) => {
  try {
    const result = await put(`news/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const updateNewsDelivery = async (data) => {
  try {
    const result = await put(`news/deliveryupdate/${data.datas}`, {
      data: data,
    });
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const deleteNews = async (id) => {
  try {
    const result = await destroy(`news/${id}`);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const bulkDeleteNews = async (ids) => {
  try {
    const result = await post(`news/bulk-delete`, { ids });
    return result;
  } catch (err) {
    return { error: err };
  }
};

// Сонгосон ачаануудын төлөвийг солино. to өгвөл тэр төлөвт, өгөхгүй бол нэг алхам ахиулна.
export const advanceNewsStatus = async (ids, to) => {
  try {
    const result = await put(`news/status/advance`, to ? { ids, to } : { ids });
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const setSpecial = async (id, data) => {
  try {
    const result = await put(`news/special/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const setCheck = async (id, data) => {
  try {
    const result = await put(`news/check/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

// Харилцагчийн нийтийн трак хайлт (нэвтрэлт шаардахгүй)
export const trackParcel = async (code) => {
  try {
    const result = await get(`news/track?code=${encodeURIComponent(code)}`);
    return result;
  } catch (err) {
    return { error: err };
  }
};

// Тайлан: шүүлттэй ачааны бүрэн жагсаалт + нэгтгэл (Excel татах, эрхийн хүрээгээр)
// params: { search, branch, type, location, startDate, endDate }
export const getNewsReport = async (params = {}) => {
  try {
    const qs = [];
    if (params.search) qs.push(`search=${encodeURIComponent(params.search)}`);
    if (params.branch) qs.push(`branch=${encodeURIComponent(params.branch)}`);
    if (params.type) qs.push(`type=${encodeURIComponent(params.type)}`);
    if (params.location) qs.push(`location=${encodeURIComponent(params.location)}`);
    if (params.startDate) qs.push(`startDate=${encodeURIComponent(params.startDate)}`);
    if (params.endDate) qs.push(`endDate=${encodeURIComponent(params.endDate)}`);
    const q = qs.length ? `?${qs.join("&")}` : "";
    const result = await get(`news/report${q}`);
    return result;
  } catch (err) {
    return { error: err };
  }
};
